(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name commons.directive:scrollMe
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="commons">
       <file name="index.html">
        <scroll-me></scroll-me>
       </file>
     </example>
   *
   */
  angular
    .module('commons')
    .directive('scrollMe', scrollMe);

  function scrollMe(EventManagerService) {
    return {
      restrict: 'A',
      replace: false,
      controllerAs: 'scrollMe',
      bindToController: true,
      controller: function () {
        var vm = this;
        vm.targetElementName = null;
      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */

        if (!!attrs['scrollMe']) {
          scope.targetElementName = attrs['scrollMe'];
        }

        function onScrollToTop(data) {
          var split = data.split(',');
          if(split[0] == scope.targetElementName){
            angular.element(element).animate({ scrollTop: 0 }, "fast");
          }
        }

        function onScrollToPoint (data) {
          var split = data.split(',');
          if(split[0] == scope.targetElementName){
            var scTop = angular.element(element).scrollTop();
            scTop +=  parseInt(split[1]);

            angular.element(element).animate({ scrollTop: scTop }, "fast");
          }
        }

        function onScrollToLeft (data) {
          var split = data.split(',');
          if(split[0] == scope.targetElementName){
            angular.element(element).animate({ scrollLeft: 0 }, "fast");
          }
        }

        EventManagerService.registerEventListener(EventManagerService.EVENT.SCROLL_TO_TOP,onScrollToTop);

        EventManagerService.registerEventListener(EventManagerService.EVENT.SCROLL_TO_LEFT,onScrollToLeft);

        EventManagerService.registerEventListener(EventManagerService.EVENT.SCROLL_TO_POINT,onScrollToPoint);
      }
    };
  }
}());
